// Regular expression for validating a UUID (version 4 specifically)
const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const prValueRegex = /^[a-zA-Z0-9]+$/;

export function isValidSessionID(sessionID?: string): boolean {
  if (!sessionID) {
    return false;
  }
  // Test the sessionID against the regex
  return uuidV4Regex.test(sessionID);
}

export function isValidPrString(prString: string): boolean {
  const prValues = prString.split(',');

  if (prValues.length < 8) {
    return false;
  }

  for (const value of prValues) {
    if (!prValueRegex.test(value)) {
      return false;
    }
  }

  return true;
}
